import { useTranslations } from "next-intl";
import Price from "../../../common/components/Price";

const ProductPrice = ({ price }) => {
  const t = useTranslations();
  return (
    <div className="product-item__price">
      <div className="fw-semibold text-end">
        <Price {...price} />
      </div>
    </div>
  );
};

export default ProductPrice;
